import { render, staticRenderFns } from "./CustomPrompt.vue?vue&type=template&id=620c6b1e&scoped=true"
import script from "./CustomPrompt.vue?vue&type=script&lang=js"
export * from "./CustomPrompt.vue?vue&type=script&lang=js"
import style0 from "./CustomPrompt.vue?vue&type=style&index=0&id=620c6b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c6b1e",
  null
  
)

export default component.exports